// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.EvolutionarySection_section-open__\\+iYfS {
  background: transparent;
  border: 0;
  box-shadow: none;
  overflow: visible;
  padding-top: 44px;
  margin: 0 auto;
  font-family: "Sora", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
}

.EvolutionarySection_point-section__81qgb {
  display: grid;
  grid-template-columns: minmax(420px, 1fr) minmax(300px, 0.82fr);
  gap: clamp(42px, 6vw, 92px);
  align-items: center;
  padding: 58px 40px;
  margin: 0 auto;
  max-width: 1280px;
}
@media (max-width: 767px) {
  .EvolutionarySection_point-section__81qgb {
    padding: 58px 20px;
  }
}
@media (max-width: 1080px) {
  .EvolutionarySection_point-section__81qgb {
    grid-template-columns: 1fr;
  }
}

.EvolutionarySection_point-content__kV6Yt {
  display: grid;
  gap: 0;
  align-content: center;
}

.EvolutionarySection_eyebrow__Omoyk {
  margin: 0 0 14px 0;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #82B194;
  text-align: left;
}
@media (max-width: 1080px) {
  .EvolutionarySection_eyebrow__Omoyk {
    text-align: center;
  }
}

.EvolutionarySection_section-title__JHi7l {
  margin: 0 0 28px 0;
  max-width: 24ch;
  font-size: 42px;
  line-height: 1.08;
  letter-spacing: -0.035em;
  font-weight: 700;
  color: #13231D;
  text-align: left;
}
@media (max-width: 1080px) {
  .EvolutionarySection_section-title__JHi7l {
    max-width: none;
    font-size: 32px;
    margin-bottom: 12px;
    text-align: center;
    max-width: none;
  }
}

.EvolutionarySection_section-copy__EYMWN {
  margin: 0;
  max-width: 780px;
  font-size: 17px;
  line-height: 1.72;
  color: #5F726B;
}
@media (max-width: 1080px) {
  .EvolutionarySection_section-copy__EYMWN {
    font-size: 16px;
    text-align: center;
    max-width: none;
  }
}

.EvolutionarySection_quote__udxf3 {
  margin: 0;
  padding: 18px 0 0;
  max-width: 820px;
  font-size: 24px;
  line-height: 1.45;
  letter-spacing: -0.02em;
  color: #13231D;
  text-align: left;
}
@media (max-width: 1080px) {
  .EvolutionarySection_quote__udxf3 {
    font-size: 18px;
    text-align: center;
    max-width: none;
  }
}

.EvolutionarySection_point-figure__iT6mD {
  margin: 0;
  width: min(100%, 500px);
  justify-self: end;
  border-radius: 30px;
  overflow: hidden;
  border: 1px solid rgba(19, 35, 29, 0.08);
  box-shadow: 0 22px 54px rgba(18, 34, 29, 0.075);
  aspect-ratio: 1.08/1;
  max-height: 520px;
  align-self: center;
  background: #F7F5F1;
}
.EvolutionarySection_point-figure__iT6mD img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
}
@media (max-width: 1080px) {
  .EvolutionarySection_point-figure__iT6mD {
    height: 360px;
    justify-self: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/Landing/EvolutionarySection/EvolutionarySection.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;ADyHA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC3HJ;;AA9BA;EACE,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,oFDLU;ACsCZ;;AA9BA;EACE,aAAA;EACA,+DAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAiCF;AA/BE;EATF;IAUI,kBAAA;EAkCF;AACF;AAhCE;EAbF;IAcI,0BAAA;EAmCF;AACF;;AAhCA;EACE,aAAA;EACA,MAAA;EACA,qBAAA;AAmCF;;AAhCA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAmCF;AAjCE;EAVF;IAWI,kBAAA;EAoCF;AACF;;AAjCA;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAoCF;AAlCE;EAVF;IAWI,eAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;EAqCF;AACF;;AAlCA;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAqCF;AAnCE;EAPF;IAQI,eAAA;IACA,kBAAA;IACA,eAAA;EAsCF;AACF;;AAnCA;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AAsCF;AApCE;EAVF;IAWI,eAAA;IACA,kBAAA;IACA,eAAA;EAuCF;AACF;;AApCA;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wCAAA;EACA,+CAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAuCF;AArCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;AAuCJ;AApCE;EArBF;IAsBI,aAAA;IACA,oBAAA;EAuCF;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n@import '../../../assets/styles/variables';\n\n.section-open {\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  overflow: visible;\n  padding-top: 44px;\n  margin: 0 auto;\n  font-family: $font-main;\n}\n\n.point-section {\n  display: grid;\n  grid-template-columns: minmax(420px, 1fr) minmax(300px, 0.82fr);\n  gap: clamp(42px, 6vw, 92px);\n  align-items: center;\n  padding: 58px 40px;\n  margin: 0 auto;\n  max-width: 1280px;\n\n  @media (max-width: 767px) {\n    padding: 58px 20px;\n  }\n\n  @media (max-width: 1080px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.point-content {\n  display: grid;\n  gap: 0;\n  align-content: center;\n}\n\n.eyebrow {\n  margin: 0 0 14px 0;\n  font-size: 12px;\n  line-height: 1.2;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #82B194;\n  text-align: left;\n\n  @media ( max-width: 1080px) {\n    text-align: center;\n  }\n}\n\n.section-title {\n  margin: 0 0 28px 0;\n  max-width: 24ch;\n  font-size: 42px;\n  line-height: 1.08;\n  letter-spacing: -0.035em;\n  font-weight: 700;\n  color: #13231D;\n  text-align: left;\n\n  @media (max-width: 1080px) {\n    max-width: none;\n    font-size: 32px;\n    margin-bottom: 12px;\n    text-align: center;\n    max-width: none;\n  }\n}\n\n.section-copy {\n  margin: 0;\n  max-width: 780px;\n  font-size: 17px;\n  line-height: 1.72;\n  color: #5F726B;\n\n  @media (max-width: 1080px) {\n    font-size: 16px;\n    text-align: center;\n    max-width: none;\n  }\n}\n\n.quote {\n  margin: 0;\n  padding: 18px 0 0;\n  max-width: 820px;\n  font-size: 24px;\n  line-height: 1.45;\n  letter-spacing: -0.02em;\n  color: #13231D;\n  text-align: left;\n\n  @media (max-width: 1080px) {\n    font-size: 18px;\n    text-align: center;\n    max-width: none;\n  }\n}\n\n.point-figure {\n  margin: 0;\n  width: min(100%, 500px);\n  justify-self: end;\n  border-radius: 30px;\n  overflow: hidden;\n  border: 1px solid rgba(19, 35, 29, 0.08); // var(--lp-border)\n  box-shadow: 0 22px 54px rgba(18, 34, 29, 0.075);\n  aspect-ratio: 1.08 / 1;\n  max-height: 520px;\n  align-self: center;\n  background: #F7F5F1; // var(--lp-card-soft)\n\n  img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: 50% 50%;\n  }\n\n  @media (max-width: 1080px) {\n    height: 360px;\n    justify-self: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section-open": `EvolutionarySection_section-open__+iYfS`,
	"point-section": `EvolutionarySection_point-section__81qgb`,
	"point-content": `EvolutionarySection_point-content__kV6Yt`,
	"eyebrow": `EvolutionarySection_eyebrow__Omoyk`,
	"section-title": `EvolutionarySection_section-title__JHi7l`,
	"section-copy": `EvolutionarySection_section-copy__EYMWN`,
	"quote": `EvolutionarySection_quote__udxf3`,
	"point-figure": `EvolutionarySection_point-figure__iT6mD`
};
export default ___CSS_LOADER_EXPORT___;
